module.exports = __webpack_public_path__ + "band_5.da6a08f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/male_to_female/band_5.png
// module id = ayPt
// module chunks = 0